import {Component, OnDestroy, OnInit} from '@angular/core';
import {ObjectList} from '../../model/object-list';
import {LeadInformationsResource} from '../../model/model-resource';
import {LeadInformation} from '../../model/lead-information';

@Component({
  selector: 'app-lead-informations-list-page',
  templateUrl: './lead-informations-list-page.component.html',
  styleUrls: ['./lead-informations-list-page.component.scss']
})
export class LeadInformationsListPageComponent implements OnInit, OnDestroy {

  leadInformations: ObjectList<LeadInformation>;
  columns = [
    'companyBusinessId',
    'companyName',
    'firstName',
    'lastName',
    'phone',
    'email',
    'created'
  ];

  constructor(private resource: LeadInformationsResource) {
  }

  ngOnInit() {
    this.leadInformations = new ObjectList<LeadInformation>('leadInformations', this.resource);
  }

  ngOnDestroy() {
    this.leadInformations.disconnect();
    this.leadInformations = null;
  }

}
